module.exports = __webpack_public_path__ + "static/media/price_calculator_back.e2b28ae1.svg";